import { render, staticRenderFns } from "./depositChannel.vue?vue&type=template&id=34a0fe07&scoped=true&"
import script from "./depositChannel.vue?vue&type=script&lang=js&"
export * from "./depositChannel.vue?vue&type=script&lang=js&"
import style0 from "./depositChannel.vue?vue&type=style&index=0&id=34a0fe07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a0fe07",
  null
  
)

export default component.exports